import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import LogoutModel from './LogoutModel';
import { fncUpdatePassengerInfo, fncGetBookingFromState, fncAddInfant, fncSaveChangesApi } from '../Utility/ApiCall.js';
import { fncAssignSearchedCheckboxes, shortcutKeyForPage, shortcutKeys } from '../Utility/CommonFun.js';
import { searchCredential } from '../ReduxState';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import subYears from 'date-fns/subYears';
import subDays from 'date-fns/subDays';
import * as moment from 'moment';
import FocusLock from "react-focus-lock";
function PassengerInformation({handleSideMenu}) {
    const [focusLocked, setFocusLocked] = useState(true);

    let history = useHistory();
    const location = useLocation();
    const redirectTo = useSelector(state => state.sidemenu.redirectionPage);
    // debugger
    const SearchedFlightDetails = useSelector(state => state.search.SearchedFlightDetails);
    const passengersForPnr = { ...SearchedFlightDetails };
    const travellingDate = passengersForPnr.journeys[0].designator.departure;
    const selectedPassengers = passengersForPnr.passenger.filter(p => p.IsSelected);
    const stSearchedRecordData = useSelector(state => state.search.SearchedRecordData);
    const SearchedSelectedPassengerData = useSelector(state => state.selectedpassenger.SelectedPassengerData);
    const dispatch = useDispatch();
    const [passengers, setPassengers] = useState(selectedPassengers && selectedPassengers.length ? selectedPassengers : []);
    const [paxInfo, setPaxInfo] = useState(selectedPassengers && selectedPassengers.length ? selectedPassengers[0] : null);
    const [passengerType, setPassengerType] = useState(selectedPassengers && selectedPassengers.length ? selectedPassengers[0].passengerTypeCode : 'ADT');
    const [triggerModal, settriggerModal] = useState(false);
    const [minDate, setMinDate] = useState(new Date());
    const [maxDate, setMaxDate] = useState(new Date());
    const [minDateInfant, setminDateInfant] = useState(subYears(new Date(travellingDate), 2));
    const [maxDateInfant, setmaxDateInfant] = useState(subDays(new Date(travellingDate), 7));
    const [st_DateError, setDateError] = useState('');
    const [infantDateError, setinfantDateError] = useState('');
    const [infantFirstNameError, setinfantFirstNameError] = useState('');
    const [infantLastNameError, setinfantLastNameError] = useState('');
    const [infantMiddleNameError, setinfantMiddleNameError] = useState('');
    const [tempDate, setTempDate] = useState(null);
    const [st_date, setDate] = useState(selectedPassengers && selectedPassengers.length && selectedPassengers[0].passengerInfo.dateOfBirth ? new Date(selectedPassengers[0].passengerInfo.dateOfBirth) : null);
    const [infantDob, setinfantDob] = useState(null);
    const [disableDob, setDisableDob] = useState(true);
    const [passengerCheckedIn, setPassengerCheckedIn] = useState(false);
    const travelWithPaxs = selectedPassengers && selectedPassengers.length && selectedPassengers.filter(sp => sp.passengerTypeCode !== 'CHD' && sp.infant === null).length > 0 ? selectedPassengers.filter(sp => sp.infant === null)[0].passengerKey : '';
    const [travellingWith, setTravellingWith] = useState(travelWithPaxs);
    const [infantGender, setInfantGender] = useState('Male');
    const [infantFirstName, setinfantFirstName] = useState('');
    const [infantLastName, setinfantLastName] = useState('');
    const [infantMiddleName, setinfantMiddleName] = useState('');
    const [infantTitle, setinfantTitle] = useState('MSTR');
    const [addInfantDisabled, setaddInfantDisabled] = useState(false);

    const notify = (e) =>
        toast.error(e, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });

    const isPassengerCheckedIn = useCallback((passengerKey) => {
        let checked = false;
        const passengerJourneys = SearchedFlightDetails.journeys;
        passengerJourneys.forEach((journey) => {
            const selectedSegment = journey.segments.filter(seg => seg.IsSelected);
            selectedSegment.forEach(seg => {
                const selectedPSegment = seg.passengerSegment.filter(pseg => pseg.IsSelected && pseg.passengerKey === passengerKey && pseg.liftStatus === "CheckedIn");
                if (selectedPSegment.length === 1) {
                    checked = true;
                }
            });
        });
        return checked;
    }, [SearchedFlightDetails]);

    useEffect(() => {
        // console.log('SearchedFlightDetails', SearchedFlightDetails, SearchedRecordData, stSearchedRecordData);
        document.addEventListener("keydown", function (event) {
            // console.log('event', event);
            if (event.key && shortcutKeys.includes(event.key)) {
                const path = shortcutKeyForPage(location.pathname, event, SearchedFlightDetails);
                if (path) {
                    history.push('/' + path);
                }
            }
        });
    });

    useEffect(() => {
        let subYearsForMaxDate;
        let subYearsForMinDate;
        if (passengerType === 'ADT') {
            subYearsForMaxDate = 12;
            subYearsForMinDate = 100;
        }
        if (passengerType === 'CHD') {
            subYearsForMaxDate = 2;
            subYearsForMinDate = 12;
        }

        setMinDate(subYears(new Date(), subYearsForMinDate));
        setMaxDate(subYears(new Date(), subYearsForMaxDate));

    }, [passengerType]);

    useEffect(() => {
        if (passengerCheckedIn) {
            notify('Passenger is already checked in. Please uncheck the passenger first if you want to edit the information');
        }
    }, [passengerCheckedIn]);

    useEffect(() => {
        debugger
        
        if (passengers.filter(p => p.passengerTypeCode !== 'CHD').every(p => p.infant !== null) || passengerCheckedIn) {
            setaddInfantDisabled(true);
        }
        setinfantDateError('');
        setinfantFirstNameError('');
        setinfantLastNameError('');
        setinfantFirstName('');
        setinfantLastName('');
        setinfantTitle('');
        setinfantDob(null);
    },[passengers, passengerCheckedIn]);

    /**
     * update currrent pnr passengers' after updating any passenger
     */
    useEffect(() => {
        const checked = isPassengerCheckedIn(selectedPassengers[0].passengerKey);
        setPassengers(selectedPassengers && selectedPassengers.length ? selectedPassengers : []);
        setPaxInfo(selectedPassengers && selectedPassengers.length ? selectedPassengers[0] : null);
        setPassengerCheckedIn(
            selectedPassengers && selectedPassengers.length ? checked : false);
        setPassengerType(selectedPassengers && selectedPassengers.length ? selectedPassengers[0].passengerTypeCode : 'ADT');
        setDate(selectedPassengers && selectedPassengers.length && selectedPassengers[0].passengerInfo.dateOfBirth ? new Date(selectedPassengers[0].passengerInfo.dateOfBirth) : null);

    }, [SearchedFlightDetails, isPassengerCheckedIn]);

    useEffect(() => {
        // Define the function that checks for the Escape key
        const handleKeyDown = (event) => {
          if (event.key === "Escape") {
            goBack(); // Close the popup
          }
        };
    
        // Add the event listener when the component mounts
        document.addEventListener("keydown", handleKeyDown);
    
        // Clean up the event listener when the component unmounts
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [redirectTo]);

    useEffect(() => {
                      //  debugger
                       document.addEventListener("keydown", function (event) {  
                         if (event.altKey && (event.key === 'Dead' || event.key === 'e')) {
                           handleSideMenu();
                         }
                       })
                     });

    const setPassengerInfo = (passengerIndex) => (event) => {
        const checkedIn = isPassengerCheckedIn(passengers[passengerIndex].passengerKey);
        setPaxInfo(passengers[passengerIndex]);
        setPassengerCheckedIn(checkedIn);
        setPassengerType(passengers[passengerIndex].passengerTypeCode);
    }

    const fncSelectTravelllingWithPassenger = (e) => {
        const val = e.target.value;
        setTravellingWith(val);
    }

    const fncSelectInfantGender = (e) => {
        const val = e.target.value;
        setInfantGender(val);
    }

    const fncInfantFirstName = (e) => {
        const result = e.target.value.replace(/[^a-z]/gi, '');
        // const val = e.target.value;
        if (result.length > 32) {
            setinfantFirstNameError('Length cannot be greater than 32 characters');
        } else {
            setinfantFirstName(result);
        }    
    }

    const fncInfantMiddleName = (e) => {
        const result = e.target.value.replace(/[^a-z]/gi, '');
        // const val = e.target.value;
        if (result.length > 32) {
            setinfantMiddleNameError('Length cannot be greater than 32 characters');
        } else {
            setinfantMiddleName(result);
        }
    }

    const fncInfantLastName = (e) => {
        const result = e.target.value.replace(/[^a-z]/gi, '');
        // const val = e.target.value;
        if (result.length > 32) {
            setinfantLastNameError('Length cannot be greater than 32 characters');
            
        } else {
            setinfantLastName(result);
        }
        
    }

    const fncInfantTitle = (e) => {
        const val = e.target.value;
        setinfantTitle(val);
    }

    const changePassengerType = (event) => {
        const currentPax = SearchedFlightDetails.passenger.filter(pax => pax.passengerKey === paxInfo.passengerKey)[0];
        if (currentPax.passengerTypeCode !== event.target.value) {
            setDisableDob(false);
            setDateError('Please provide date of birth.')
            setTempDate(st_date);
            if (!st_date) {
                setDisableDob(true);
                setDate(tempDate);
                setDateError('');
            } else {
                setDate(null);
            }
        }

        setPassengerType(event.target.value);
        const passengersArr = [...passengers];
        // const currentPax = passengers.filter(p => p.name.first === paxInfo.name.first)[0];
        // currentPax.passengerTypeCode = event.target.value;
        passengersArr.forEach(pax => {
            if (pax.name.first === paxInfo.name.first) {
                pax.passengerTypeCode = event.target.value;
            }
        })
        setPassengers(passengersArr);
    }

    function handleDateChange(e) {
        setDateError('');
        setDate(e);
    }

    function handleInfantDateChange(e) {
        setinfantDob(e);
    }

    function goBack() {
        history.push(redirectTo);
    }

    const addInfant = (e) => {
        // debugger
        
        console.log('infantDob', infantDob, new Date(infantDob), moment(infantDob).format(), moment.utc(infantDob))
        if (infantDob === null) {
            setinfantDateError('Please select date of birth for infant.')
            return;
        }
        if (infantFirstName === '') {
            setinfantFirstNameError('Please provide first name');
            return;
        }

        if (infantLastName === '') {
            setinfantLastNameError('Please provide last name');
            return;
        }
        const infantFormattedDob = moment(infantDob).format();
        const apiBody = [{
            "passengerkey": travellingWith,
            "InfantInfo": {
                "Nationality": 'IN',
                "DateofBirth": infantFormattedDob.substr(0, infantFormattedDob.indexOf('T')),
                "residentCountry": "IN",
                "Gender": infantGender,
                "name":
                {
                    "first": infantFirstName,
                    "middle": infantMiddleName,
                    "last": infantLastName,
                    "title": infantTitle
                }
            }
        }];
        setFocusLocked(true);
        fncAddInfant(apiBody)
            .then(infantAdded => {
                const modalCloseButton = document.getElementById('modalCloseIcon');
                if (infantAdded.status == "401" && infantAdded.data == "") {
                    document.getElementById("showAndHideSpinner").style.display = "none";
                    settriggerModal(true);
                    modalCloseButton.click();
                } else {
                    if (!infantAdded.data.isError && infantAdded.data.addinfantreponsemodel[0].isInfantAdded) {
                        fncSaveChangesApi()
                            .then((returnVal) => {
                                if (returnVal.status == "401" && returnVal.data == "") {
                                    document.getElementById("showAndHideSpinner").style.display = "none";
                                    settriggerModal(true);
                                }
                                else {
                                    document.getElementById("showAndHideSpinner").style.display = "none";
                                    if (!returnVal.data.isError) {


                                        document.getElementById("showAndHideSpinner").style.display = "block";
                                        fncGetBookingFromState()
                                            .then((returnVal) => {
                                                if (returnVal.status == "401" && returnVal.data == "") {
                                                    document.getElementById("showAndHideSpinner").style.display = "none";
                                                    settriggerModal(true);
                                                }
                                                else {

                                                    if (!returnVal.data.isError) {
                                                        if (returnVal.data.flightDetails != null) {
                                                            var assignStateAgain = fncAssignSearchedCheckboxes(SearchedSelectedPassengerData, returnVal.data.flightDetails, "UPDATEPAXINFO");
                                                        }
                                                        dispatch(searchCredential(
                                                            {
                                                                type: "",
                                                                SearchedRecordData: stSearchedRecordData,
                                                                SearchedFlightDetails: assignStateAgain
                                                            }
                                                        ));
                                                        
                                                        modalCloseButton.click();
                                                    }
                                                    else {
                                                        document.getElementById("showAndHideSpinner").style.display = "none";
                                                        console.log(returnVal.data.errorDetail);
                                                        modalCloseButton.click();
                                                        notify(returnVal.data.errorDetail.errorMessage);
                                                    }
                                                    document.getElementById("showAndHideSpinner").style.display = "none";
                                                }

                                            })
                                            .catch(err => console.log("Axios err: ", err))

                                    }
                                    else {
                                        document.getElementById("showAndHideSpinner").style.display = "none";
                                        modalCloseButton.click();
                                        notify(returnVal.data.errorDetail.errorMessage);
                                    }
                                }

                            })
                            .catch(e => console.log('Axios e: ', e));

                    } else {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        modalCloseButton.click();
                        notify(infantAdded.data.errorDetail.errorMessage);
                    }

                }
            })
            .catch(err => console.log("Axios err: ", err));

    }

    const updatePassengerInfo = (e) => {
        const apiBody = {
            RecordLocator: SearchedFlightDetails.recordLocator,
            PassengerKey: paxInfo.passengerKey,
            PassengerTypeCode: passengerType
        }
        if (st_date) {
            apiBody.DateOfBirth = st_date;
        }
        fncUpdatePassengerInfo([apiBody])
            .then(updatePaxResult => {
                if (updatePaxResult.status == "401" && updatePaxResult.data == "") {
                    document.getElementById("showAndHideSpinner").style.display = "none";
                    settriggerModal(true);
                } else {
                    if (!updatePaxResult.data.isError && updatePaxResult.data.passengerInfoResponses[0].isSuccess) {
                        fncGetBookingFromState()
                            .then((returnVal) => {
                                if (returnVal.status == "401" && returnVal.data == "") {
                                    document.getElementById("showAndHideSpinner").style.display = "none";
                                    settriggerModal(true);
                                }
                                else {

                                    if (!returnVal.data.isError) {
                                        if (returnVal.data.flightDetails != null) {
                                            var assignStateAgain = fncAssignSearchedCheckboxes(SearchedSelectedPassengerData, returnVal.data.flightDetails, "UPDATEPAXINFO");
                                        }
                                        dispatch(searchCredential(
                                            {
                                                type: "",
                                                SearchedRecordData: stSearchedRecordData,
                                                SearchedFlightDetails: assignStateAgain
                                            }
                                        ));
                                    }
                                    else {
                                        document.getElementById("showAndHideSpinner").style.display = "none";
                                        console.log(returnVal.data.errorDetail);
                                        notify(returnVal.data.errorDetail.errorMessage);
                                    }
                                    document.getElementById("showAndHideSpinner").style.display = "none";
                                }

                            })
                            .catch(err => console.log("Axios err: ", err))
                    } else {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        console.log(updatePaxResult.data.errorDetail);
                        notify(updatePaxResult.data.errorDetail.errorMessage);
                    }
                }
                document.getElementById("showAndHideSpinner").style.display = "none";
            })
            .catch(err => console.log("Axios err: ", err));

    }

    const handleCloseModal = () => {
        setFocusLocked(true); 
    };

    return (
        <div>
            <LogoutModel trigger={triggerModal}> </LogoutModel>
            <div >
                <div class="card-pInfo white">
                    <div class="passenger-heading-outer">
                        <div class="passenger-heading">
                            <h4 class="font-xxl mb-3 dark-text">Passengers</h4>
                            <button data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#addInfant"  disabled={addInfantDisabled} onClick={()=>setFocusLocked(false)} class="btn btn-primary btn-animation SerachBtn">Add Infant</button>
                        </div>
                    </div>
                    <div class="pInfo-content-outer-heading">
                        <div class="pInfo-heading">
                            <div class="d-flex px-1 py-2">
                                <div class="s-no">
                                    <p class="dark-text bold font-md mb-0">S.No.</p>
                                </div>
                                <div class="pName">
                                    <p class="dark-text bold font-md mb-0">Passenger Name</p>
                                </div>
                            </div>
                        </div>
                        <div class="pInfo-content">
                        </div>
                    </div>
                    <div class="pInfo-content-outer">
                        <ul class="nav nav-tabs pInfo-heading" id="myTab" role="tablist">
                            {
                                passengers.length && passengers.map((pax, index) =>
                                    <li class="nav-item">
                                        <a class={index === 0 ? "nav-link active d-block" : "nav-link d-block"} id={index} data-toggle="tab" href="#kumarTarun"
                                            role="tab" aria-controls="kumarTarun" aria-selected="true" onClick={setPassengerInfo(index)}>
                                                <div class="d-flex">
                                                    <span class="sr-no">{index + 1}{`.`}</span>
                                                    <span class="p-name">{`${pax.name.last}, ${pax.name.first} ${pax.name.title}`}</span>
                                                </div>
                                            
                                                {pax.infant ?
                                                <div class="infantName">
                                                    <img src="newImages/infant-red.svg" />
                                                    <span class="infant-name">{`${pax.infant.name.last}, ${pax.infant.name.first} ${pax.infant.name.title}`}</span>
                                                </div>
                                                : null
                                                }
                                        </a>
                                    </li>
                                )
                            }
                        </ul>
                        <div class="tab-content pInfo-content" id="myTabContent">
                            <div class="tab-pane fade show active" id="tarun" role="tabpanel" aria-labelledby="tarun-tab">
                                <div class="row">
                                    <div class="col-sm-12 py-2 mb-2 ">
                                        <p class="dark-text bold font-lg mb-0">Passenger Information</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 col-lg-4 mb-3">
                                        <div class="form-group form-floating">
                                            <input type="text" class="form-control" autocomplete="" placeholder="CUSTOMER ID" name="customer-id" value="" />
                                            <label class="bold dark-text" for="customer-id">Customer ID</label>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-4 mb-3">
                                        <div class="form-group form-floating">
                                            <input type="text" class="form-control" autocomplete="" placeholder="CUSTOMER PROGRAM" name="customer-program" disabled value="" />
                                            <label class="bold dark-text" for="customer-program">Customer Program</label>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-4 mb-3">
                                        <div class="form-group form-floating">
                                            <input type="text" class="form-control" autocomplete="new-fname" placeholder="PASSENGER NAME" name="pName" disabled value={paxInfo ? `${paxInfo.name.last}, ${paxInfo.name.first} ${paxInfo.name.title}` : ''} />
                                            <label class="bold dark-text" for="pName">Passenger Name</label>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-4 mb-3">
                                        <div class="form-group form-floating">
                                            <select class="form-control" value={paxInfo ? (['MR', 'MSTR'].includes(paxInfo.name.title) ? 'Male' : 'Female') : ''} disabled required="" aria-label="gender">
                                                <option value="Female">Female</option>
                                                <option value="Male">Male</option>
                                            </select>
                                            <label class="bold dark-text" for="genter">Gender</label>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-4 mb-3">
                                        <div class="form-group form-floating ">
                                            <select class="form-control" value={paxInfo ? paxInfo.name.title : "MR"} disabled required="" aria-label="title">
                                                <option value="MRS">Mrs</option>
                                                <option value="MR">Mr</option>
                                                <option value="MS">Ms</option>
                                                <option value="MISS">Miss</option>
                                                <option value="MSTR">Master</option>
                                            </select>
                                            <label class="bold dark-text" for="title">Title</label>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-4 mb-3">
                                        <div class="form-floating date ">
                                            <DatePicker
                                                autocomplete="new-date"
                                                name="date"
                                                className="form-control"
                                                dateFormat="dd-MM-yyyy"
                                                placeholderText="DATE OF BIRTH"
                                                wrapperClassName="dobdatePicker"
                                                minDate={minDate}
                                                maxDate={maxDate}
                                                peekNextMonth
                                                showMonthDropdown
                                                showYearDropdown
                                                selected={st_date}
                                                disabled={disableDob || passengerCheckedIn}
                                                // onSelect={(e) => { handleDateSelect(e) }}
                                                onChange={(e) => { handleDateChange(e) }}
                                            />
                                            <span class="icon sp-formFieldIcon-right"></span>
                                            <p className="clsErrorDate" >{st_DateError}</p>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-4 mb-3">
                                        <div class="form-group form-floating">
                                            <select
                                                class="form-control focusClass"
                                                value={passengerType}
                                                onChange={changePassengerType}
                                                disabled={passengerCheckedIn}
                                                required=""
                                            >
                                                <option value="ADT">Adult</option>
                                                <option value="CHD">Child</option>
                                            </select>
                                            <label class="bold dark-text" for="title">Type</label>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-4 mb-3">
                                        <div class="form-group form-floating">
                                            <select class="form-control" required="" disabled aria-label="nationality">
                                                <option selected="" value=""></option>
                                                <option value="usa">USA</option>
                                                <option value="India">India</option>
                                            </select>
                                            <label class="bold dark-text" for="nationality">Nationality</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12 pb-2 mt-2 pt-4 ">
                                        <p class="dark-text bold font-lg mb-0">Emergency Contact</p>
                                    </div>
                                </div>
                                <div class="row ">
                                    <div class="col-12 col-lg-4 mb-3">
                                        <div class="form-group form-floating">
                                            <input type="text" class="form-control" autocomplete="" placeholder="Contact Name" name="c-name" value="" />
                                            <label class="bold dark-text" for="c-name">Contact Name</label>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-4 mb-3">
                                        <div class="form-group form-floating">
                                            <input type="text" class="form-control" autocomplete="" placeholder="Phone" name="phone" value="" />
                                            <label class="bold dark-text" for="phone">Phone</label>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-4 mb-3">
                                        <div class="form-group form-floating">
                                            <input type="text" class="form-control" autocomplete="" placeholder="Address" name="address" value="" />
                                            <label class="bold dark-text" for="address">Address</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12 pb-2 mt-2 pt-4">
                                        <p class="dark-text bold font-lg mb-0">Frequent Flyer Numbers</p>
                                    </div>
                                </div>
                                <div class="row ">
                                    <div class="col-12 col-lg-4 mb-3">
                                        <div class="form-group form-floating">
                                            <input type="text" class="form-control" autocomplete="" placeholder="Carrier 1" name="carrier1" value="" />
                                            <label class="bold dark-text" for="carrier1">Carrier 1</label>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-4 mb-3">
                                        <div class="form-group form-floating">
                                            <input type="text" class="form-control" autocomplete="" placeholder="Carrier 2" name="carrier2" value="" />
                                            <label class="bold dark-text" for="carrier2">Carrier 2</label>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-4 mb-3">
                                        <div class="form-group form-floating">
                                            <input type="text" class="form-control" autocomplete="" placeholder="Carrier 3" name="carrier3" value="" />
                                            <label class="bold dark-text" for="carrier3">Carrier 3</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="btn-container  d-flex justify-content-end mt-4 pb-3">
                                    <button class="btn btn-primary btn-animation me-4 SerachBtn" disabled={passengerCheckedIn} onClick={updatePassengerInfo}>
                                        <span class="px-4"> Update</span>
                                    </button>
                                    <button class="btn btn-white btn-animation me-4 SerachBtn" onClick={goBack}>
                                        <span class="px-4">Cancel</span>
                                    </button>
                                </div>
                            </div>
                        </div>


                        {/* <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true"></div> */}

                    </div>
                </div>
            </div>
            {/* {
                infantModalShow ? <p>asjkcnsdjcnwcj sdfcjkds svsj </p> */}
                <FocusLock disabled={focusLocked}>
                    <div class="modal fade " data-dismiss="modal" aria-labelledby="staticBackdropLabel"  data-bs-backdrop="static" data-toggle="modal" tabindex="-1" aria-hidden="true" id="addInfant"> 
                    {/* data-dismiss="modal" aria-labelledby="staticBackdropLabel"  data-bs-backdrop="static" data-toggle="modal" tabindex="-1" aria-hidden="true" class="modal fade " */}
                        <div class="modal-dialog modal-dialog-centered infant-modal">
                            <div class="modal-content">
                                <div class="heading mb-4">
                                    <a id="modalCloseIcon" data-bs-dismiss="modal"  class="modal-close">
                                        <i class="fa fa-times"></i>
                                    </a>
                                    <h4 class="font-xxl bold dark-text mb-0">Add Infant Information</h4>
                                </div>
                                <div class="addInfantForm">

                                    <div class="row">

                                        <div class="col-12 col-lg-4 mb-3">
                                            <div class="form-group form-floating">
                                                <select class="form-control focusClass" required="" value={infantTitle} onChange={e => fncInfantTitle(e)} id="genter" aria-label="genter">
                                                    <option value="MSTR">Master</option>
                                                    <option value="MISS">Miss</option>
                                                </select>
                                                <label class="bold dark-text" for="infant-name">Title</label>
                                            </div>
                                        </div>

                                        <div class="col-12 col-lg-4 mb-3">
                                            <div class="form-group form-floating">
                                                <input type="text" class="form-control" value={infantFirstName} onChange={e => fncInfantFirstName(e)} placeholder="Infant Name" name="infant-name" />
                                                <label class="bold dark-text" for="infant-name">First Name</label>
                                                <p className="clsErrorDate" >{infantFirstNameError}</p>
                                            </div>
                                        </div>

                                        <div class="col-12 col-lg-4 mb-3">
                                            <div class="form-group form-floating">
                                                <input type="text" class="form-control" value={infantMiddleName} onChange={e => fncInfantMiddleName(e)} placeholder="Infant Name" name="infant-name" />
                                                <label class="bold dark-text" for="infant-name">Middle Name</label>
                                                <p className="clsErrorDate" >{infantMiddleNameError}</p>
                                            </div>
                                        </div>

                                        <div class="col-12 col-lg-4 mb-3">
                                            <div class="form-group form-floating">
                                                <input type="text" class="form-control" value={infantLastName} onChange={e => fncInfantLastName(e)} placeholder="Infant Name" name="infant-name" />
                                                <label class="bold dark-text" for="infant-name">Last Name</label>
                                                <p className="clsErrorDate" >{infantLastNameError}</p>
                                            </div>
                                        </div>
                                        <div class="col-12 col-lg-4 mb-3">
                                            <div class="form-group form-floating">
                                                <select class="form-control focusClass" required="" value={infantGender} onChange={e => fncSelectInfantGender(e)} id="genter" aria-label="genter">
                                                    {/* <option value=""></option> */}
                                                    <option value="Male">Male</option>
                                                    <option value="Female">Female</option>
                                                </select>
                                                <label class="bold dark-text" for="genter">Gender</label>
                                            </div>
                                        </div>

                                        <div class="col-12 col-lg-4 mb-3">
                                            <div class="form-floating date ">
                                                <DatePicker
                                                    // autocomplete="new-date"
                                                    name="date"
                                                    className="form-control"
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="DATE OF BIRTH"
                                                    wrapperClassName="dobdatePicker"
                                                    minDate={minDateInfant}
                                                    maxDate={maxDateInfant}
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    selected={infantDob}
                                                    // disabled={disableDob || passengerCheckedIn}
                                                    onChange={(e) => { handleInfantDateChange(e) }}
                                                />
                                                <span class="icon fa fa-calendar sp-formFieldIcon-right"></span>
                                                <p className="clsErrorDate" >{infantDateError}</p>
                                                {/* <label class="bold dark-text" for="dateInput">Date Of Birth</label> */}
                                            </div>
                                        </div>
                                        <div class="col-12 col-lg-4 mb-3">
                                            <div class="form-group form-floating">
                                                <select class="form-control focusClass" required="" disabled id="nationality" aria-label="nationality">

                                                    <option value="India">India</option>
                                                </select>
                                                <label class="bold dark-text" for="nationality">Nationality</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-12 pb-2 mt-2 pt-4 ">
                                            <p class="dark-text bold font-lg mb-0">Service</p>
                                        </div>
                                    </div>
                                    <div class="row ">
                                        <div class="col-12 col-lg-4 mb-3">
                                            <div class="form-group form-floating">
                                                <select class="form-control focusClass" onChange={e => fncSelectTravelllingWithPassenger(e)} aria-label="TravellingWith">
                                                    {
                                                        passengers.length && passengers.filter(p => p.infant === null && p.passengerTypeCode !== 'CHD').map((pax, index) =>
                                                            <option value={pax.passengerKey}>{pax.name.last + "," + pax.name.first + " " + pax.name.title}</option>
                                                        )
                                                    }
                                                </select>
                                                <label class="bold dark-text" for="travellingWith">Travelling With</label>
                                            </div>
                                        </div>
                                        {/* <div class="col-12 col-lg-4 mb-3">
                                <div class="form-group form-floating">
                                    <input type="text" class="form-control" autocomplete="" placeholder="Segments" name="segments" value="" />
                                    <label class="bold dark-text" for="segments">Segments</label>
                                </div>
                            </div> */}
                                        <div class="col-12 col-lg-4 mb-3">
                                            <div class="form-group form-floating">
                                                <input type="text" class="form-control focusClass" disabled autocomplete="" placeholder="Total Price" name="totalPrice" value="" />
                                                <label class="bold dark-text" for="totalPrice">Total Price</label>
                                            </div>
                                        </div>
                                        <div class="col-12 col-lg-12 mb-3">
                                            <div class="form-group form-floating">
                                                <input type="text" class="form-control focusClass" disabled autocomplete="" placeholder="notes" name="notes" value="" />
                                                <label class="bold dark-text" for="notes">Notes</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="btn-container  d-flex justify-content-end mt-4 pb-3">
                                        <button class="btn btn-primary btn-animation me-4 SerachBtn" onClick={addInfant} >
                                            <span class="px-4"> Add</span>
                                        </button>
                                        <button class="btn btn-white btn-animation SerachBtn" onClick={handleCloseModal} data-bs-dismiss="modal" >
                                            <span class="px-4">Cancel</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> 
                    </FocusLock>
                {/* : null
            } */}
        </div>
    );
}

export default PassengerInformation;